function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1425",
  dataname: "Group 1425",
  transform: "translate(-182.671 -247.671)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_875",
  dataname: "Group 875",
  transform: "translate(-14 310.624)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_874",
  dataname: "Group 874"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_873",
  dataname: "Group 873"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1737",
  dataname: "Rectangle 1737",
  width: 41.235,
  height: 41.235,
  transform: "translate(196.671 -62.953)",
  fill: "none"
})))), /*#__PURE__*/React.createElement("path", {
  fill: "var(--error)",
  d: "M4048.231,1979.682h-32.224a4,4,0,0,1-3.35-6.186l16.112-24.682a4,4,0,0,1,6.7,0l16.112,24.682a4,4,0,0,1-3.35,6.186Zm-15.756-8.587a2.231,2.231,0,0,0-1.62.6,2.054,2.054,0,0,0-.619,1.524,2.029,2.029,0,0,0,.619,1.516,2.513,2.513,0,0,0,3.255,0,2.184,2.184,0,0,0,0-3.046A2.264,2.264,0,0,0,4032.475,1971.1ZM4030,1954.863l.473,14.034h3.671l.473-14.034Z",
  transform: "translate(-3829 -1695.682)"
}));

var SvgEroor = function SvgEroor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 41.235 41.235",
    style: {
      zIndex: 999999
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEroor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eroor.ee7a373b.svg";
export { ForwardRef as ReactComponent };